export default "__VITE_ASSET__15a5b902__"